import { ColumnConfig } from '@/components/table/Table';

export const commerceSettingsTableColumns: ColumnConfig[] = [
  {
    field: 'key',
    label: 'Clave',
    sortable: true,
  },
  {
    field: 'value',
    label: 'Valor',
    sortable: true,
  },
  {
    field: 'longValue',
    label: 'Valor Detallado',
    sortable: false,
    render: (value: string) => (
      <span className='max-w-xs truncate block'>{value}</span>
    ),
  },
  {
    field: 'numberValue',
    label: 'Valor Numérico',
    sortable: true,
    render: (value: number) => {
      if (value === undefined || value === null) return '-';
      return value.toString();
    },
  },
  {
    field: 'dateValue',
    label: 'Valor de Fecha',
    sortable: true,
    render: (value: string) => {
      if (!value) return '-';
      return new Date(value).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
  },
];
